<script>
    import {PRConnect} from "@projectroom/ui-lib";
    import {onDestroy, onMount} from 'svelte';
    import {navigateTo} from 'svelte-router-spa';
	import Thumbnail from './../event-components/Thumbnail.svelte';
	import EventInfo from './../event-components/EventInfo.svelte';
	import Applicants from './../event-components/Applicants.svelte';
	import RankingBoard from './../event-components/RankingBoard.svelte';
	import AnnouncementResult from './../event-components/AnnouncementResult.svelte';
	import Management from './../event-components/Management.svelte';
	import { messaging } from "./store/messaging-store";

    export let currentRoute;
	let event = {};
	class Event {

		constructor({id, title, subTitle, proccessType, startDate, endDate, mainImageContent, content, notice, resultDate, thumbnailContent, thumbnailTitle, thumbnailSubTitle, rankingFlag, rankingViewCount = 12, rankingViewType, resultMainImageContent, resultContent, resultNotice, eventType, receiveContent, popupTitle, popupLink, eventShareFlag}) {
			this.id = id;
			this.title = title;
			this.subTitle = subTitle; 
			this.proccessType = proccessType; 
			this.startDate = startDate; 
			this.endDate = endDate; 
			this.mainImageContent = mainImageContent; 
			this.content = content; 
			this.notice = notice; 
			this.resultDate = resultDate; 
			this.thumbnailContent = thumbnailContent; 
			this.thumbnailTitle = thumbnailTitle; 
			this.thumbnailSubTitle = thumbnailSubTitle;
			this.rankingFlag = rankingFlag; 
			this.rankingViewCount = rankingViewCount; 
			this.rankingViewType = rankingViewType;
			this.resultMainImageContent = resultMainImageContent; 
			this.resultContent = resultContent; 
			this.resultNotice = resultNotice; 
			this.eventType = eventType; 
			this.receiveContent = JSON.parse(receiveContent); 
			this.popupTitle = popupTitle; 
			this.popupLink = popupLink;
			this.eventShareFlag = eventShareFlag;
			this.currentTab = "thumbnail";
			this.isLoad = true;
		}

		setApplicantList(applicantList) {
			this.applicantList = applicantList;
			this.assign();
		}

		isRankingFlag() {
			return this.rankingFlag === "Y";
		}
		isEventShareFlag() {
			return this.eventShareFlag === "Y";
		}

		isReceiveContent(content) {
			return this.receiveContent.includes(content);
		}

		isEventType(eventType) {
			return this.eventType === eventType;
		}

		changeTitle(title) {
			if (this.title == title) {
				return;
			}
			this.title = title;
			this.save();
		}

		changeSubTitle(subTitle) {
			if (this.subTitle == subTitle) {
				return;
			}
			this.subTitle = subTitle;
			this.save();
		}

		changeRankingFlag() {
			this.rankingFlag = this.rankingFlag === "Y" ? "N" : "Y";
			this.save();
		}

		changeEventShareFlag() {
			this.eventShareFlag = this.eventShareFlag === "Y" ? "N" : "Y";
			this.save();
		}

		changeReceiveContent(content) {
			if (this.receiveContent.includes(content)) {
				this.receiveContent = this.receiveContent.filter(e => e !== content);
			} else {
				this.receiveContent.push(content);
			}
			this.save();
		}

		changeThumbnailContent(thumbnailContent) {
			this.thumbnailContent = thumbnailContent;
			this.save();
		}

		changeMainImageContent(mainImageContent) {
			this.mainImageContent = mainImageContent;
			this.save();
		}
		changeResultMainImageContent(resultMainImageContent) {
			this.resultMainImageContent = resultMainImageContent;
			this.save();
		}

		changeContent(content) {
			if (this.content == content) {
				return;
			}
			this.content = content;
			this.save();
		}

		changeEventType(eventType) {
			if (this.eventType == eventType) {
				return;
			}
			this.eventType = eventType;
			this.popupTitle = null;
			this.save();
		}

		changePopupTitle(popupTitle) {
			if (this.popupTitle == popupTitle) {
				return;
			}
			this.popupTitle = popupTitle;
			this.save();
		}

		changePopupLink(popupLink) {
			if (this.popupLink == popupLink) {
				return;
			}
			this.popupLink = popupLink;
			this.save();
		}
		
		changeNotice(notice) {
			if (this.notice == notice) {
				return;
			}
			this.notice = notice;
			this.save();
		}

		changeResultContent(resultContent) {
			if (this.resultContent == resultContent) {
				return;
			}
			this.resultContent = resultContent;
			this.save();
		}

		changeResultNotice(resultNotice) {
			if (this.resultNotice == resultNotice) {
				return;
			}
			this.resultNotice = resultNotice;
			this.save();
		}

		changeRankingViewCount(rankingViewCount) {
			if (this.rankingViewCount == rankingViewCount) {
				return;
			}
			this.rankingViewCount = rankingViewCount;
			this.save();
		}

		changeDate(type, day, hour) {
			hour = Number(hour) < 10 ? `0${hour}`: hour;
			const date = `${day} ${hour}:00:00`;
			if (this[type] === date) {
				return;
			}
			this[type] = date;
			this.save();
		}
		

		getThumbnailContent() {
            return this.thumbnailContent ? `https://groovworks-avatalk-public-file-storage.s3.ap-northeast-2.amazonaws.com/common/event/${this.id}/${this.thumbnailContent}` : "";
        }
		
		getMainImageContent() {
			return this.mainImageContent ? `https://groovworks-avatalk-public-file-storage.s3.ap-northeast-2.amazonaws.com/common/event/${this.id}/detail/${this.mainImageContent}` : "";
		}

		getResultMainImageContent() {
			return this.resultMainImageContent ? `https://groovworks-avatalk-public-file-storage.s3.ap-northeast-2.amazonaws.com/common/event/${this.id}/detail/${this.resultMainImageContent}` : "";
		}

		getStartDay() {
			return this.startDate?.substring(0,10);
		}

		getEndDay() {
			return this.endDate?.substring(0,10);
		}

		getResultDay() {
			return this.resultDate?.substring(0,10);
		}
		
		getStartTime() {
			return new Date(this.startDate).getHours();
		}

		getEndTime() {
			return new Date(this.endDate).getHours();
		}

		getResultTime() {
			return new Date(this.resultDate).getHours();
		}

		changeCurrentTab(currentTab) {
			this.currentTab = currentTab;
			this.assign();
		}

		changeThumbnailTitle(thumbnailTitle) {
			if (this.thumbnailTitle == thumbnailTitle) {
				return;
			}
			this.thumbnailTitle = thumbnailTitle;
			this.save();
		}

		changeThumbnailSubTitle(thumbnailSubTitle) {
			if (this.thumbnailSubTitle == thumbnailSubTitle) {
				return;
			}
			this.thumbnailSubTitle = thumbnailSubTitle;
			this.save();
		}
		
		deleteThumbnailContent() {
			this.thumbnailContent = null;
			this.save();
		}

		deleteMainImageContent() {
			this.mainImageContent = null;
			this.save();
		}
		
		deleteResultMainImageContent() {
			this.resultMainImageContent = null;
			this.save();
		}

		save() {
			PRConnect.send("/api/Event/modifyEventPre", {...this, receiveContent: JSON.stringify(this.receiveContent)}, data => {
				if (data.header.status === "success") {
					console.log("Event update success");
					this.assign();
					messaging.set({ target:"EventBuilderLayout", action:"update" });
				}
			});
			this.assign();
		}

		assign() {
            event = event;
        }
	}

	onMount(() => {
		const eventId = currentRoute.namedParams.eventId;
		PRConnect.send("/api/Event/getEventPreForModify", {id : eventId}, data => {
			if (data.header.status === "success") {
				event = new Event(data.result);
			}
		});
    });
	

    const clickCurrentTab = (e) => {
		const currentTab = e.target.closest("a").dataset.tab;
		event.changeCurrentTab(currentTab);
    }
</script>
<div class="ava-event admin">
      <div class="eventdetail-con-wrap">
        <div class="eventadmin-con">
          <div data-current="Tab 5" data-easing="ease" data-duration-in="300" data-duration-out="100" class="tabs w-tabs">
            <div class="tabs-menu w-tab-menu" on:click={clickCurrentTab}>
              <a data-tab="thumbnail" class="tab-link-tab-1 w-inline-block w-tab-link" class:w--current={event.currentTab === "thumbnail"}>
                <div>썸네일 구성</div>
              </a>
              <a data-tab="eventInfo" class="tab-link-tab-2 w-inline-block w-tab-link" class:w--current={event.currentTab === "eventInfo"}>
                <div>이벤트 정보 입력</div>
              </a>
              <a data-tab="rankingBoard" class="tab-link-tab-3 w-inline-block w-tab-link" class:w--current={event.currentTab === "rankingBoard"}>
                <div>랭킹보드</div>
              </a>
              <a data-tab="announcementResult" class="tab-link-tab-3 w-inline-block w-tab-link" class:w--current={event.currentTab === "announcementResult"}>
                <div>결과발표 입력</div>
              </a>
              <a data-tab="management" class="tab-link-tab-3 w-inline-block w-tab-link" class:w--current={event.currentTab === "management"}>
                <div>이벤트 관리</div>
              </a>
              <a data-tab="applicants" class="tab-link-tab-3 w-inline-block w-tab-link" class:w--current={event.currentTab === "applicants"}>
                <div>신청인 관리</div>
              </a>
            </div>
            <div class="tabs-content w-tab-content">
              <Thumbnail {event} /> 
              <EventInfo {event} />
              <RankingBoard {event} />
              <AnnouncementResult {event} />
              <Management {event} />
              <Applicants {event} {currentRoute}/>
            </div>
          </div>
        </div>
      </div>
    </div>
<style>
	
	.eventadmin-con {
		min-height: 1300px;
	}

	.tabs-content {
    	height: 70%;
		min-height: 1000px;
	}

	.tabs {
		height: 80%;
	}
	.ava-event {
		margin-top: 40px;
	}
</style>